export interface StageState {
   user: string
   project: any
   partnerRoles:string[]
}

export const initialStageState: StageState = {
   user: null,
   project: null,
   partnerRoles: ['ADMIN', 'PARTNER', 'ECOFFICER', 'ADVISORY_BOARD', 'USER_GROUP'],
}

